import { RootState } from "@/redux/store";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "sonner";
import privateApiClient from "@/services/axios/private-api-client";
import * as API from '../@api/update'
export const getRFQ = createAsyncThunk<
  any,
  void,
  { state: RootState }
>(
  "user_buyer_rfq/getRFQ",
  async (_, { rejectWithValue }) => {
    try {
      const response = await API.getRFQDetails();
      return response;
    } catch (error: any) {
      toast.error(error?.meta?.message || "Failed to fetch RFQ details", {
        classNames: {
          toast: "!bg-red-500 !text-white",
        },
      });
      return rejectWithValue(error?.response || error?.message);
    }
  }
);


export const getRFQDetails = createAsyncThunk<
  any,
  void,
  { state: RootState }
>(
  "user_buyer_rfq/getRFQDetails",
  async (_, { rejectWithValue }) => {
    try {
      const response = await API.getRFQDetails();
      return response;
    } catch (error: any) {
      toast.error(error?.meta?.message || "Failed to fetch RFQ details", {
        classNames: {
          toast: "!bg-red-500 !text-white",
        },
      });
      return rejectWithValue(error?.response || error?.message);
    }
  }
);
export const thunks = {
  getRFQDetails,
};